import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { apiAuthInterceptor } from './app/core/auth/auth.interceptor';
import { authErrorInterceptor } from './app/core/interceptors/auth-error.interceptor';
import { appRoutes } from './app.routes';

// Auth is OUR login page + OUR API (/central/auth/*, server-side Cognito exchange) — the OIDC
// client library and its hosted-UI redirect flow are gone. apiAuthInterceptor attaches the access
// token exactly where the library's authInterceptor did; the guard on the shell route replaces
// checkAuth-and-redirect.
export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([apiAuthInterceptor, authErrorInterceptor])),
        provideZonelessChangeDetection(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } })
    ]
};
